import {initUser} from './forms/user';
import {initProducts} from './forms/products';
import {initRecipes} from './forms/recipes';
import {initSimilarRecipes} from './forms/similar-recipes';
import {initKitchenwares} from './forms/kitchenwares';
import {initExercises} from './forms/exercises';
import {initTrainings} from './forms/trainings';
import {initPractices} from './forms/practices';
import {initPayments} from './forms/payments';
import {initSubscriptions} from './forms/subscriptions';
import {initTariffs} from './forms/tariffs';
import {initEmails} from './forms/emails';
import {initEmailTemplates} from './forms/email-templates';
import {initProgrammTasks} from './forms/programm-tasks';
import {initManagerTasks} from './forms/manager-tasks';
import {initProgramms} from './forms/programms';
import {initLogin} from './forms/login';
import {initImagesUpload} from './forms/images-upload';
import {initVideoUpload} from './forms/video-upload';
import {initUserParams} from './forms/user-params';
import {initAddButtons} from './forms/add-buttons';
import { initInitialPractices } from './forms/initial-practices';
import { initInitialRecommendations } from './forms/initial-recommendations';
import { initSearchForm } from './forms/search-form';
import { initRecalculateStats } from './forms/recalculate-stats';

export class Client {
    constructor($, apiClient, filesClient, authClient) {
        this.$ = $;
        this.apiClient = apiClient;
        this.filesClient = filesClient;
        this.authClient = authClient;
    }

    initialize() {
        initUser(this.$, this.apiClient);
        initProducts(this.$, this.apiClient);
        initRecipes(this.$, this.apiClient);
        initSimilarRecipes(this.$, this.apiClient);
        initKitchenwares(this.$, this.apiClient);
        initExercises(this.$, this.apiClient);
        initTrainings(this.$, this.apiClient);
        initPractices(this.$, this.apiClient);
        initPayments(this.$, this.apiClient);
        initSubscriptions(this.$, this.apiClient);
        initTariffs(this.$, this.apiClient);
        initEmails(this.$, this.apiClient);
        initEmailTemplates(this.$, this.apiClient);
        initProgrammTasks(this.$, this.apiClient);
        initManagerTasks(this.$, this.apiClient);
        initProgramms(this.$, this.apiClient);
        initLogin(this.$, this.authClient);
        initImagesUpload(this.$, this.filesClient);
        initVideoUpload(this.$, this.filesClient);
        initUserParams(this.$, this.apiClient);
        initAddButtons(this.$, this.apiClient);
        initInitialPractices(this.$, this.apiClient);
        initInitialRecommendations(this.$, this.apiClient);
        initSearchForm(this.$);
        initRecalculateStats(this.$, this.apiClient);
    }
}
